<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center p-3 globalborder-btm-header mb-3">
        <span class="col-auto">
          <h2 class="mb-0">Client Settlement</h2>
        </span>

        <div class="d-flex gap-3 align-items-center">
          <div class="col-auto">
            <p-button
              label="Export Excel"
              variant="outlined"
              icon="pi pi-cloud-upload"
              severity="secondary"
              (click)="exportExcelFile()"
              class="fullwdth secondary-btn" />
          </div>

          <span class="cross-border" (click)="closeSettleEvent()"
            ><i class="pi pi-times"></i
          ></span>
        </div>
      </span>
      <div class="col-lg-12 adduser-container-hgt">
        <p-table
          #dt
          stripedRows
          [size]="'small'"
          scrollHeight="300px"
          [showCurrentPageReport]="true"
          [paginator]="false"
          responsiveLayout="scroll"
          [value]="customerSettlementDetailLists"
          styleClass="table-listing popuptable"
          [rowHover]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [autoLayout]="true"
          [resizableColumns]="true"
          [paginator]="customerSettlementDetailLists.length >= 50">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th>Date of Settlement</th>
              <th>Offset Voucher</th>
              <th>Account</th>
              <th>Created By</th>
              <th>Offset Currency</th>
              <th>Offset Amount</th>
              <th>Amount Settled</th>
              <th>Settled Currency</th>
            </tr>
            <tr>
              <th>
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    name="TransDate"
                    id="TransDate"
                    class="date-filter"
                    onfocus="(this.type='date')"
                    onblur="if(!this.value) this.type='text'"
                    (change)="onTransDateFilter($event)" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="OffsetTransVoucher"
                    id="OffsetTransVoucher"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'OffsetTransVoucher',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="AccountNum"
                    id="AccountNum"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'AccountNum',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="CreatedBy1"
                    id="CreatedBy1"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'CreatedBy1',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-customerSettlementDetailLists
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="customerSettlementDetailLists"
              [pSelectableRowIndex]="rowIndex">
              <td>
                {{
                  customerSettlementDetailLists.TransDate | date: "MM-dd-yyyy"
                }}
              </td>
              <td>
                {{ customerSettlementDetailLists.OffsetTransVoucher }}
              </td>
              <td>
                <a
                  class="link"
                  (click)="
                    redirectToClient(customerSettlementDetailLists.AccountNum)
                  ">
                  {{ customerSettlementDetailLists.AccountNum }}</a
                >
              </td>
              <td>{{ customerSettlementDetailLists.CreatedBy1 }}</td>
              <td>{{ customerSettlementDetailLists.OffsetCurrency }}</td>
              <td>
                {{ customerSettlementDetailLists.OffsetAmount | number }}
              </td>
              <td>
                {{ customerSettlementDetailLists.SettleAmountMST | number }}
              </td>
              <td>
                {{ customerSettlementDetailLists.SettleAmountCur | number }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="30">No Data Found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<!-- <div class="orders py-3 pagination-order">
  <header
    class="orders-header d-flex align-items-center justify-content-between has-border pb-2 mb-4">
    <h1>Client Settlement 2</h1>
    <div class="orders-panel col-auto d-flex justify-content-between">
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="icon-Export-excel me-2"></i>
        <a class="link" (click)="exportExcelFile()">Export excel</a>
      </div>
      <div>
        <i class="pi pi-times" (click)="closeSettleEvent()"></i>
      </div>
    </div>
  </header>

  <div class="p-wrapper-custom">
    <p-table
      #dt
      responsiveLayout="scroll"
      [value]="customerSettlementDetailLists"
      styleClass="p-datatable-customers"
      [rowHover]="true"
      [rows]="20"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 20, 50, 1000]"
      [autoLayout]="true"
      [resizableColumns]="true"
      [paginator]="customerSettlementDetailLists.length >= 20">
      <ng-template pTemplate="header">
        <tr>
          <th>Date of Settlement</th>
          <th>Offset Voucher</th>
          <th>Account</th>
          <th>Created By</th>
          <th>Offset Currency</th>
          <th>Offset Amount</th>
          <th>Amount Settled</th>
          <th>Settled Currency</th>
        </tr>
        <tr>
          <th>
            <div class="d-flex">
              <input pInputText 
                jniAutoCompleteBlocker
                name="TransDate"
                id="TransDate"
                class="date-filter"
                onfocus="(this.type='date')"
                onblur="if(!this.value) this.type='text'"
                (change)="onTransDateFilter($event)" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input pInputText 
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="OffsetTransVoucher"
                id="OffsetTransVoucher"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'OffsetTransVoucher',
                    'contains'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input pInputText 
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="AccountNum"
                id="AccountNum"
                style="max-width: 200px"
                (input)="
                  dt.filter($any($event.target).value, 'AccountNum', 'contains')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input pInputText 
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="CreatedBy1"
                id="CreatedBy1"
                style="max-width: 200px"
                (input)="
                  dt.filter($any($event.target).value, 'CreatedBy1', 'contains')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-customerSettlementDetailLists
        let-rowIndex="rowIndex">
        <tr
          class="p-selectable-row"
          [pSelectableRow]="customerSettlementDetailLists"
          [pSelectableRowIndex]="rowIndex">
          <td>
            {{ customerSettlementDetailLists.TransDate | date: "MM-dd-yyyy" }}
          </td>
          <td>
            {{ customerSettlementDetailLists.OffsetTransVoucher }}
          </td>
          <td>
            <a
              class="link"
              (click)="
                redirectToClient(customerSettlementDetailLists.AccountNum)
              ">
              {{ customerSettlementDetailLists.AccountNum }}</a
            >
          </td>
          <td>{{ customerSettlementDetailLists.CreatedBy1 }}</td>
          <td>{{ customerSettlementDetailLists.OffsetCurrency }}</td>
          <td>
            {{ customerSettlementDetailLists.OffsetAmount | number }}
          </td>
          <td>
            {{ customerSettlementDetailLists.SettleAmountMST | number }}
          </td>
          <td>
            {{ customerSettlementDetailLists.SettleAmountCur | number }}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="30">No Data Found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div> -->
